

import { IMPROVE_CONFIG } from "@/config.js";
import axios from "axios";

export default {
    adminGetCompanyUsers: function (id, params, search) {
        return axios.get(IMPROVE_CONFIG.API_URL + "/company/admin/users/" + id + params + search);
    },
    adminGetCompany: function (id, params) {
        return axios.get(IMPROVE_CONFIG.API_URL + "/admin/company/" + id + params);
    },
    getPartnerCustomerReports: function() {
        return axios.get(IMPROVE_CONFIG.API_URL + "/get-all-customers-report");
    },
    createEdifyImproveContent: function(created_id,customer_id) {
        return axios.post(IMPROVE_CONFIG.API_URL + "/edifyimprovecontents/"+created_id, {
        //   all_content:  improveContent.all_content,
        //   leg_regulation :improveContent.leg_regulation,
        //   people_relationship:improveContent.people_relationship,
        //   online_safety:improveContent.online_safety,
        //   digital_skills:improveContent.digital_skills,
        //   management_leadership:improveContent.management_leadership,
        //   wfh_toolkit:improveContent.wfh_toolkit,
        //   no_of_users:improveContent.no_of_users,
        //   annual_price:improveContent.annual_price,
          customer_id:customer_id,
          content_type:0,
        });
    },
    createEdifyContent: function(created_id,customer_id) {
        return axios.post(IMPROVE_CONFIG.API_URL + "/edifyimprovecontents/"+created_id, {
        //   all_content:  improveContent.all_content,
        //   leg_regulation :improveContent.leg_regulation,
        //   people_relationship:improveContent.people_relationship,
        //   online_safety:improveContent.online_safety,
        //   digital_skills:improveContent.digital_skills,
        //   management_leadership:improveContent.management_leadership,
        //   wfh_toolkit:improveContent.wfh_toolkit,
        //   no_of_users:improveContent.no_of_users,
        //   annual_price:improveContent.annual_price,
          customer_id:customer_id,
          content_type:1,
        });
    },
    getImproveContent: function(userId) {
        return axios.get(IMPROVE_CONFIG.API_URL + "/getimprovecontent/" + userId);
    },
    removeEdifyImproveContent: function(companyId, customerId, removeEdifyImproveContent, packageId) {
        if(packageId != '')
            return axios.delete(IMPROVE_CONFIG.API_URL + "/edifyimprovecontents/" + companyId + '/' + removeEdifyImproveContent + '/' + customerId + '/' + packageId);
        else
            return axios.delete(IMPROVE_CONFIG.API_URL + "/edifyimprovecontents/" + companyId + '/' + removeEdifyImproveContent + '/' + customerId);
    },
    getMembershipPackages: function(){
        return axios.get(IMPROVE_CONFIG.API_URL + "/getAllMembershipPackages");
    },
    createMembershipContent: function(created_id, customer_id, company_id, package_id) {
        return axios.post(IMPROVE_CONFIG.API_URL + "/edifyimprovecontents/"+created_id, {
              customer_id:customer_id,
              company_id:company_id,
              package_id: package_id,
              content_type:2,
            });
    },
    getLeadsData: function(){
        return axios.get(IMPROVE_CONFIG.API_URL + '/get_leads');
    },
    getBandingPackages: function(){
        return axios.get(IMPROVE_CONFIG.API_URL + '/get-superadmin-banding-packages');
    },
    createBandingPackage: function(packageInfo){
    return axios.post(IMPROVE_CONFIG.API_URL + '/create_package',{
            banding_id: packageInfo.banding_id,
            package_id: packageInfo.id,
            max_course: packageInfo.maxCourses,
            title: packageInfo.name
        });
    },
    updateBandingPackage: function(packageInfo){
        return axios.post(IMPROVE_CONFIG.API_URL + '/update_package',{
            banding_id: packageInfo.banding_id,
            package_id: packageInfo.id,
            max_course: packageInfo.maxCourses,
            title: packageInfo.name
        });
    },
    deleteBandingPackage: function(packageId){
        return axios.delete(IMPROVE_CONFIG.API_URL + '/delete_package/'+packageId);
    },
    getPackageFromBandingId: function(bandingId){
        return axios.get(IMPROVE_CONFIG.API_URL + '/get-packages/'+bandingId);
    },
    getAllReleases: function(params){
            return axios.get(IMPROVE_CONFIG.API_URL + '/releases'+params);
    },
    getReleaseUpdates: function(releaseId){
        return axios.get(IMPROVE_CONFIG.API_URL + '/releases/'+releaseId);
    },
    saveReleaseUpdates: function(updates, s3, file){
            return axios.post(IMPROVE_CONFIG.API_URL + '/releases/save',{
            id: updates.id,
            title: updates.title,
            release_date: updates.release_date,
            features: updates.features,
            s3_url: s3,
            file: file,
        });
    },
    deleteReleaseUpdates: function(releaseId){
        return axios.delete(IMPROVE_CONFIG.API_URL + '/releases/'+releaseId);
    },
    // Course rollout (2D): preview is a zero-write dry run; apply queues the
    // audited job; rollouts is the audit trail the screen polls.
    previewCourseRollout: function(payload){
        return axios.post(IMPROVE_CONFIG.API_URL + '/super-admin/course-rollout/preview', payload);
    },
    applyCourseRollout: function(payload){
        return axios.post(IMPROVE_CONFIG.API_URL + '/super-admin/course-rollout', payload);
    },
    getRolloutPlaylists: function(companyId){
        return axios.get(IMPROVE_CONFIG.API_URL + '/super-admin/rollout-playlists?company_id=' + companyId);
    },
    getCourseRollouts: function(){
        return axios.get(IMPROVE_CONFIG.API_URL + '/super-admin/course-rollouts');
    },
};
